module.exports = __webpack_public_path__ + "img/glas_1.f806705d.png";